import { render } from "./PromoTwoView.vue?vue&type=template&id=3c8e04e7"
import script from "./PromoTwoView.vue?vue&type=script&lang=js"
export * from "./PromoTwoView.vue?vue&type=script&lang=js"

import "./PromoTwoView.vue?vue&type=style&index=0&id=3c8e04e7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__